export const en = {
    'validation-empty-name': 'Video name not entered',
    'validation-empty-text': 'The value cannot be empty'
};
